import { useLanguage } from "./LanguageContext";
import { useCallback } from "react";

export const Translator = () => {
  const { lang } = useLanguage();

  const translateText = useCallback(async (text, sourceLang = "it") => {
    if (!text || lang === sourceLang) return text;

    try {
      const url = `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/translate?text=${encodeURIComponent(text)}&toLang=${encodeURIComponent(lang.toLowerCase())}`;
      encodeURIComponent(lang.toLowerCase())

      const response = await fetch(url);
      const translated = await response.text(); // handle plain text
      return translated || text;
    } catch (error) {
      //console.error("Translation failed:", error);


      // do not translate if there's an error
      // do not translate words: email??
      return text;
    }
  }, [lang]);

  return { translateText, lang };
};
